import { AppState } from '../app-state/app-state';
import { flexPeriodAdapter } from './flex-periods.reducer';
import { getFlexPeriodState } from './flex-periods.state';

export const getFlexPeriodCollection = flexPeriodAdapter.getSelectors(getFlexPeriodState).selectAll;
export const getFlexPeriodById = (id: number) => (state: AppState) => state.flexPeriods.entities[id];
